<div class="striped-rows flex-md-last flex-lg-first">
    <div class="row">
        <div class="col-md-12 col-lg-3"></div>
        <div class="col-md-12 col-lg-9"></div>
    </div> 
    <div class="row">
        <div class="col-md-12 col-lg-3">
            <strong>Status:</strong>
        </div>
        <div class="col-md-12 col-lg-9">
            <ng-template #stageApproverContent>
                <ul class="assigned-users">
                    <li *ngFor="let assignedUsers of currentStageUsers()">
                        {{ assignedUsers.FirstName }} {{ assignedUsers.LastName }}
                    </li>
                </ul>
            </ng-template>
            <b>{{ userCycle.PendingStatus }}</b>
            <i *ngIf="userCycle.UserStatus === CplUserStatus.PENDING"
                class="fas fa-info-circle ms-1" aria-hidden="true"
                [ngbPopover]="stageApproverContent" popoverTitle="Approvers"
                triggers="mouseenter:mouseleave"></i>
        </div>
    </div>
    <div class="row evidence-row">
        <div class="col-md-12 col-lg-3">
            <strong>Evidence:</strong>
        </div>
        <div class="col-md-12 col-lg-9">
            <span *ngIf="evidence.length === 0">-</span>
            <ul class="links">
                <li *ngFor="let attachment of evidence">
                    <i class="fas fa-paperclip me-1"></i> <button type="button" class="btn btn-link" [innerHtml]="attachment.DisplayName" (click)="viewAttachement(attachment)"></button>
                </li>
            </ul>
        </div>
    </div>
    <div class="row questionnare-row">
        <div class="col-md-12 col-lg-3">
            <strong>Completed Questionnaires:</strong>
        </div>
        <div class="col-md-12 col-lg-9">
            <span *ngIf="!userCycle.QfmID">-</span>
            <ul class="links d-flex align-items-center flex-row" *ngIf="userCycle.QfmID">
                <i *ngIf="complianceItem.QfmRequired" class="fas fa-asterisk required small me-1" ngbTooltip="Required" aria-hidden="true"></i>
                <button type="button" class="btn btn-link text-truncate" [innerHtml]="userCycle.QfmDisplayTitle" (click)="onCompleteQuestionnaire(userCycle.QfmID)"></button>
            </ul>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 col-lg-3">
            <strong>History:</strong>
        </div>
        <div class="col-md-12 col-lg-9">
            <ul class="history-item">
                <li *ngFor="let _historyItem of verificationHistory">
                    <user-cycle-history-item [historyItem]="_historyItem"></user-cycle-history-item>
                </li>
            </ul>
        </div>
    </div>
</div>